import { Component } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface ImageInsertDialogParams {
  url: string;
  height: number;
  width: number;
}

@Component({
  templateUrl: './image-insert-dialog.component.html',
  standalone: false
})
export class ImageInsertDialogComponent {
  params!: ImageInsertDialogParams;
  imageUrl: string;
  imageWidth = '';
  imageHeight = '';
  ratio?: number;
  isAspect = false;
  static config: DynamicDialogConfig = { header: 'Set Image Size', width: '800px', height: '300px' };

  constructor(
    public config: DynamicDialogConfig<ImageInsertDialogParams>,
    public dialogRef: DynamicDialogRef,
  ) {
    this.params = this.config.data as any;
    Object.assign(this.config, { width: '800px', height: '300px' });
    this.config.header = 'Add Image';
    this.imageUrl = this.params.url;
    if (this.params.height && this.params.width) {
      this.imageHeight = '' + this.params.height;
      this.imageWidth = '' + this.params.width;
      this.ratio = this.params.height / this.params.width;
      this.isAspect = true;
    }
  }

  onHeightChange() {
    if (!this.isAspect || !this.ratio) { return; }
    const flt = Number.parseFloat(this.imageHeight);
    if (!Number.isNaN(flt)) {
      this.imageWidth = (flt / this.ratio).toFixed(3);
    }
  }

  onWidthChange() {
    if (!this.isAspect || !this.ratio) { return; }
    const flt = Number.parseFloat(this.imageWidth);
    if (!Number.isNaN(flt)) {
      this.imageHeight = (flt * this.ratio).toFixed(3);
    }
  }

  canSave() {
    return this.imageUrl && this.imageUrl.match(/^http/);
  }

  save() {
    if (!this.canSave()) { return; }
    const attr = { src: this.imageUrl, inline: true } as any;
    const w = this.getDimension(this.imageWidth);
    const h = this.getDimension(this.imageHeight);
    const style = (w ? `width: ${w};` : '') + (h ? ` height: ${h};` : '');
    if (style.length > 5) {
      attr.style = style;
      attr.width = w;
      attr.height = h;
    }
    this.dialogRef.close(attr);
  }

  cancel() {
    this.dialogRef.close();
  }

  /** Convert imageWidth or imageHeight into CSS dimension */
  getDimension(s: string) {
    if (!s) { return; }
    // if only numbers, assume pixels
    return (!s.match || s.match(/^[.0-9]*$/)) ? s + 'px' : s;
  }

}
